// el archivo tiene una version mejor en views/administracion/services



import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

export const fetchAllEspecialidades = async (fields=['id', 'descripcion', 'codEsp']) => {
  const queryFields = fields.join(',');

  const query = `
    query {
      allEspecialidad {
        ${queryFields}
      }
    }
  `;

  try {
    const response = await axios.post(rutas.axios + 'api', { query });
    const { data } = response
    return data?.data?.allEspecialidad || [];
  } catch (error) {
    console.error('An error occurred while fetching the options:', error);
    return [];
  }
}


export const fetchEspecialidadesSelect = async () => {
  // console.log('voy a solicitar especialidades al backend');
  const listEspecialidades = await fetchAllEspecialidades();
  if (!Array.isArray(listEspecialidades)) return [];
  return listEspecialidades.map(
    item => ({
      value: item.id,
      text : item.descripcion,
      codigo: item.codEsp
    })
  );
}

const getOptionById = () => {

}


export const especialidadService = {
  getOptionsSelect: fetchEspecialidadesSelect,
}
